const SHIPPING_CONFIG = {
  senderAddress: 'Leuchtenbergerweg 1, 94481 Grafenau, Deutschland',
  freeShippingKm: 50,
  shippingFeeEur: 69,
  googleApiKey: 'AIzaSyCVis9iVkKIMmnCVqJNVnUeT1PlGv-BLAE',
  shippingTag: 'requires-shipping-check',
  shippingProductHandle: 'versandkosten',
  freeShippingDiscountCode: 'WH8HYK2WFQ22',
};

let pendingFormData = null;
let pendingForm = null;
let shippingFeeVariantId = null;
let calculatedShippingFree = false;

async function loadShippingVariantId() {
  try {
    const res = await fetch(`/products/${SHIPPING_CONFIG.shippingProductHandle}.js`);
    if (!res.ok) return;
    const data = await res.json();
    if (data.variants && data.variants.length > 0) {
      shippingFeeVariantId = data.variants[0].id;
    }
  } catch (e) {
    console.warn('Versandkosten-Produkt nicht gefunden:', e);
  }
}

async function geocodeAddress(address) {
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${SHIPPING_CONFIG.googleApiKey}`;
  const res = await fetch(url);
  const data = await res.json();
  if (data.status === 'OK' && data.results.length > 0) {
    const result = data.results[0];
    const acceptedTypes = ['ROOFTOP', 'RANGE_INTERPOLATED'];
    if (!acceptedTypes.includes(result.geometry.location_type)) {
      return null;
    }
    const hasStreetNumber = result.address_components.some(c => c.types.includes('street_number'));
    const hasRoute = result.address_components.some(c => c.types.includes('route'));
    if (!hasStreetNumber || !hasRoute) {
      return null;
    }
    return result.geometry.location;
  }
  return null;
}

function haversineDistance(a, b) {
  const R = 6371;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLon = ((b.lng - a.lng) * Math.PI) / 180;
  const lat1 = (a.lat * Math.PI) / 180;
  const lat2 = (b.lat * Math.PI) / 180;
  const x =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
  return R * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x));
}

async function calculateDistance(destination) {
  const [originCoords, destCoords] = await Promise.all([
    geocodeAddress(SHIPPING_CONFIG.senderAddress),
    geocodeAddress(destination),
  ]);
  if (!originCoords || !destCoords) return null;
  const straightLineKm = haversineDistance(originCoords, destCoords);
  return Math.round(straightLineKm * 1.3);
}

function resetCalculation() {
  document.getElementById('shipping-result').style.display = 'none';
  document.getElementById('shipping-result').className = 'shipping-modal-result';
  document.getElementById('shipping-confirm-btn').style.display = 'none';
  document.getElementById('shipping-check-btn').style.display = '';
  calculatedShippingFree = false;
}

function showShippingModal(form, formData) {
  pendingForm = form;
  pendingFormData = formData;
  calculatedShippingFree = false;

  const modal = document.getElementById('shipping-check-modal');
  modal.style.display = 'flex';
  modal.classList.add('is-open');

  document.getElementById('shipping-street').value = '';
  document.getElementById('shipping-zip').value = '';
  document.getElementById('shipping-city').value = '';

  const confirmBtn = document.getElementById('shipping-confirm-btn');
  confirmBtn.disabled = false;
  confirmBtn.textContent = 'In den Warenkorb legen';

  resetCalculation();
}

function hideShippingModal() {
  const modal = document.getElementById('shipping-check-modal');
  modal.style.display = 'none';
  modal.classList.remove('is-open');
}

function showResult(html, type) {
  const el = document.getElementById('shipping-result');
  el.innerHTML = html;
  el.className = `shipping-modal-result ${type}`;
  el.style.display = '';
}

async function removeShippingFeeFromCart(cart) {
  if (!shippingFeeVariantId) return;
  const shippingItem = cart.items.find(item => item.variant_id === shippingFeeVariantId);
  if (!shippingItem) return;

  const miniCart = document.querySelector('mini-cart');
  const sectionsToRender = miniCart ? miniCart.getSectionsToRender().map(s => s.section) : [];

  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: shippingItem.key,
        quantity: 0,
        sections: sectionsToRender,
        sections_url: window.location.pathname,
      }),
    });
    const response = await res.json();
    if (miniCart && response.sections) {
      miniCart.renderContents(response);
    }
  } catch (e) {
    console.warn('Fehler beim Entfernen der Versandkosten:', e);
  }
}

async function removeOrphanedShippingFee() {
  if (!shippingFeeVariantId) return;

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const hasShippingFee = cart.items.some(item => item.variant_id === shippingFeeVariantId);
    if (!hasShippingFee) return;

    // Prüfen ob noch andere Produkte (außer Versandkosten selbst) im Warenkorb sind
    const nonShippingItems = cart.items.filter(item => item.variant_id !== shippingFeeVariantId);
    if (nonShippingItems.length === 0) {
      await removeShippingFeeFromCart(cart);
    }
  } catch (e) {
    console.warn('Fehler beim Prüfen des Warenkorbs:', e);
  }
}

async function confirmAddToCart() {
  const variantInput = pendingForm ? pendingForm.querySelector('input[name="id"]') : null;
  const variantId = variantInput ? parseInt(variantInput.value) : null;
  const quantityInput = pendingForm ? pendingForm.querySelector('input[name="quantity"]') : null;
  const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

  if (!variantId) {
    showResult('Fehler: Produkt konnte nicht identifiziert werden.', 'error');
    return;
  }

  const confirmBtn = document.getElementById('shipping-confirm-btn');
  confirmBtn.disabled = true;
  confirmBtn.textContent = '⏳ Wird hinzugefügt...';

  const miniCart = document.querySelector('mini-cart');

  try {
    const items = [{ id: variantId, quantity }];
    if (!calculatedShippingFree && shippingFeeVariantId) {
      items.push({ id: shippingFeeVariantId, quantity: 1 });
    }

    const sectionsToRender = miniCart ? miniCart.getSectionsToRender().map(s => s.section) : [];

    const body = { items };
    if (sectionsToRender.length > 0) {
      body.sections = sectionsToRender;
      body.sections_url = window.location.pathname;
    }

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const err = await res.json();
      console.error('Cart error:', err);
      showResult(err.description || 'Fehler beim Hinzufügen zum Warenkorb.', 'error');
      confirmBtn.disabled = false;
      confirmBtn.textContent = 'In den Warenkorb legen';
      return;
    }

    const response = await res.json();

    if (calculatedShippingFree) {
      localStorage.setItem('wh_free_shipping_code', SHIPPING_CONFIG.freeShippingDiscountCode);
    }

    if (miniCart && response.sections) {
      miniCart.renderContents(response);
      hideShippingModal();
      setTimeout(() => miniCart.open(), 300);
    } else {
      hideShippingModal();
      window.location.reload();
    }

  } catch (err) {
    console.error('Fetch error:', err);
    showResult('Netzwerkfehler. Bitte versuche es erneut.', 'error');
    confirmBtn.disabled = false;
    confirmBtn.textContent = 'In den Warenkorb legen';
  }
}

function patchCheckoutButtons() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[name="checkout"], a[href="/checkout"], button[href*="checkout"]');
    if (!btn) return;
    const code = localStorage.getItem('wh_free_shipping_code');
    if (!code) return;
    e.preventDefault();
    localStorage.removeItem('wh_free_shipping_code');
    window.location.href = `/checkout?discount=${code}`;
  });
}

function initShippingCheck() {
  document.addEventListener(
    'submit',
    async (e) => {
      const form = e.target;
      if (!form || form.dataset.type !== 'add-to-cart-form') return;

      const productTagsEl = form.closest('[data-product-tags]');
      const tags = productTagsEl ? productTagsEl.dataset.productTags : '';

      if (!tags.includes(SHIPPING_CONFIG.shippingTag)) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      showShippingModal(form, new FormData(form));
    },
    true
  );
}

document.addEventListener('DOMContentLoaded', () => {
  loadShippingVariantId();
  initShippingCheck();
  patchCheckoutButtons();

  document.getElementById('shipping-modal-close')?.addEventListener('click', hideShippingModal);

  document.getElementById('shipping-check-modal')?.addEventListener('click', (e) => {
    if (e.target.id === 'shipping-check-modal') hideShippingModal();
  });

  ['shipping-street', 'shipping-zip', 'shipping-city'].forEach(id => {
    document.getElementById(id)?.addEventListener('input', resetCalculation);
  });

  document.getElementById('shipping-check-btn')?.addEventListener('click', async () => {
    const street = document.getElementById('shipping-street').value.trim();
    const zip = document.getElementById('shipping-zip').value.trim();
    const city = document.getElementById('shipping-city').value.trim();

    if (!street || !zip || !city) {
      showResult('Bitte alle Felder ausfüllen.', 'error');
      return;
    }

    const destination = `${street}, ${zip} ${city}, Deutschland`;

    document.getElementById('shipping-btn-text').style.display = 'none';
    document.getElementById('shipping-btn-loader').style.display = '';
    document.getElementById('shipping-check-btn').disabled = true;

    try {
      const km = await calculateDistance(destination);

      document.getElementById('shipping-btn-text').style.display = '';
      document.getElementById('shipping-btn-loader').style.display = 'none';
      document.getElementById('shipping-check-btn').disabled = false;

      if (km === null) {
        showResult('Adresse konnte nicht gefunden werden. Bitte gib eine vollständige Adresse mit Straße, Hausnummer, PLZ und Ort ein.', 'error');
        return;
      }

      if (km <= SHIPPING_CONFIG.freeShippingKm) {
        calculatedShippingFree = true;
        showResult(`✅ Entfernung: ca. ${km} km – <strong>Lieferung kostenlos!</strong>`, 'free');
      } else {
        calculatedShippingFree = false;
        showResult(`📦 Entfernung: ca. ${km} km – Versandkosten: <strong>${SHIPPING_CONFIG.shippingFeeEur},00 €</strong>`, 'paid');
      }

      document.getElementById('shipping-check-btn').style.display = 'none';
      document.getElementById('shipping-confirm-btn').style.display = '';

    } catch (err) {
      document.getElementById('shipping-btn-text').style.display = '';
      document.getElementById('shipping-btn-loader').style.display = 'none';
      document.getElementById('shipping-check-btn').disabled = false;
      showResult('Fehler bei der Berechnung. Bitte versuche es erneut.', 'error');
    }
  });

  document.getElementById('shipping-confirm-btn')?.addEventListener('click', confirmAddToCart);

  // Versandkosten automatisch entfernen wenn abhängiges Produkt entfernt wird
  document.addEventListener('cart:item-remove', async () => {
    await removeOrphanedShippingFee();
  });

  document.addEventListener('cart:item-quantity-update', async () => {
    await removeOrphanedShippingFee();
  });
});